module.exports = __webpack_public_path__ + "static/s4-icon-central-b982506dd0a91ce2954a417094009fdf.png";